// Minimum time between hover replays of the glass sheen, so jittery pointer movement at the edge of
// the image does not restart the sweep over and over.
export const SHEEN_COOLDOWN_MS = 1500;

export const isSheenReplayAllowed = (lastPlayedAt: number, now: number) =>
  now - lastPlayedAt >= SHEEN_COOLDOWN_MS;
